import React, { forwardRef } from 'react';

import Section from '../../containers/Section';
import Card from './Card/Card';
import gammovies from '../../assets/gammovies.png';
import bba from '../../assets/bba.png';
import mrtomroastery from '../../assets/mrtomroastery.png';

import { useInView } from 'react-intersection-observer';

const contentData = [
  { image: gammovies, title: 'Gammovies', desc: 'Unofficial movie rating web apps.', backgroundClass: 'bg-slate-400', link: 'https://gammovies.netlify.app/' },
  { image: bba, title: 'PT. Batulicin Beton Asphalt', desc: 'Unofficial company profile page.', backgroundClass: 'bg-violet-500', link: 'https://batulicinbetonasphalt.netlify.app/' },
  { image: mrtomroastery, title: 'Mr Tom Roastery', desc: 'Coffee roaster service and survey.', backgroundClass: 'bg-amber-900', link: 'https://mrtomroastery.netlify.app/' }
]

const Project = forwardRef((_, ref) => {
  const { ref: inViewRef, inView } = useInView({
    threshold: 0.4,
    triggerOnce: true
  })

  return (
    <Section innerClass="pb-10 max-w-[90%] xl:max-w-[80%] lg:pt-16 2xl:my-24" outerClass="bg-slate-100/30" ref={inViewRef}>
      <div className="uppercase text-xl text-center pt-16 tracking-widest text-slate-700 lg:text-2xl 2xl:text-3xl" ref={ref}>Project</div>
      <div className={`flex flex-col items-center pt-16 space-y-8 transition duration-1000 ${inView ? 'opacity-100 md:translate-y-0' : 'opacity-0 md:translate-y-full'} md:flex-row md:flex-wrap md:space-y-0 md:min-h-full md:opacity-100`}>
        {contentData.map(content => (
          <Card
            key={content.title}
            title={content.title}
            desc={content.desc}
            outerClass={content.backgroundClass}
            image={content.image}
            link={content.link}
          />
        ))}
      </div>
    </Section>
  );
});

export default Project;
